var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { IconButton as MuiIconButton } from '@mui/material';
import NavbarButtonDrawer from '../NavbarButtonDrawer';
import Text from '../Text';
import { useRef, useState } from 'react';
import colors from '../../themes/colors';
var Button = styled(MuiIconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto;\n  padding: 0;\n  transition: background-color 0.2s ease-in-out;\n\n  & title {\n    pointer-events: none;\n  }\n\n  & svg path {\n    fill: ", ";\n    transition: fill 0.2s ease-in-out;\n  }\n\n  &:hover {\n    & svg path: {\n      fill: ", ";\n    }\n  }\n"], ["\n  margin: 0 auto;\n  padding: 0;\n  transition: background-color 0.2s ease-in-out;\n\n  & title {\n    pointer-events: none;\n  }\n\n  & svg path {\n    fill: ", ";\n    transition: fill 0.2s ease-in-out;\n  }\n\n  &:hover {\n    & svg path: {\n      fill: ", ";\n    }\n  }\n"])), function (_a) {
    var active = _a.active;
    return colors[active ? 'proximaGreen20' : 'neutral20'];
}, colors.neutral5);
var ButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 0;\n  text-align: center;\n\n  &:hover {\n    background-color: ", ";\n    cursor: pointer;\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 0;\n  text-align: center;\n\n  &:hover {\n    background-color: ", ";\n    cursor: pointer;\n  }\n"])), function (_a) {
    var active = _a.active;
    return (active ? colors.neutral90 : 'transparent');
}, function (_a) {
    var active = _a.active;
    return (active ? colors.proximaGreen20 : colors.neutral20);
}, colors.neutral80);
var CLOSE_DRAWER_TIMEOUT = 400;
export default function NavBarButton(props) {
    var button = props.button, _a = props.isActive, isActive = _a === void 0 ? false : _a, onClick = props.onClick, drawerItems = props.drawerItems;
    var close = useRef(-1);
    var _b = useState(false), showDrawer = _b[0], setShowDrawer = _b[1];
    var onHoverIn = function () {
        clearTimeout(close.current);
        if (drawerItems && !showDrawer) {
            setShowDrawer(true);
        }
    };
    var onClose = function (skip) {
        if (skip === void 0) { skip = false; }
        close.current = window.setTimeout(function () {
            if (showDrawer)
                setShowDrawer(false);
        }, skip ? 0 : CLOSE_DRAWER_TIMEOUT);
    };
    return (_jsxs(ButtonContainer, __assign({ active: isActive, onMouseEnter: onHoverIn, onMouseOver: onHoverIn, onMouseLeave: function () { return onClose(); } }, { children: [_jsx(Button, __assign({ onClick: onClick, active: isActive }, { children: button.icon })), _jsx(Text, __assign({ variant: "tag2Semibold" }, { children: button.label })), drawerItems && _jsx(NavbarButtonDrawer, __assign({}, drawerItems, { show: showDrawer, onClose: onClose }))] })));
}
var templateObject_1, templateObject_2;
